import * as apiService from "./v2/apiService";
import { apiCallWithoutToken } from "./apiService";
import { baseURL } from "@/constants/v2/endPoints";

export const getMyAgentPage = () => apiService.apiCall(`${baseURL}api/v2/agent-page/me`, "GET", {});

export const recordBioOpen = (slug, body = {}) =>
  apiCallWithoutToken(`${baseURL}api/v2/public/agents/${encodeURIComponent(slug)}/opens`, "POST", body);
